import classnames from 'classnames';
import * as style from './Switcher.css';
import { WANT_KNOW_TYPE } from 'shared/constants/wantType';
import { ArticleHeading1, ArticleHeading4, ArticleParagraph1, useDeviceType } from '@cian/ui-kit';
import { EWantTypeId } from 'shared/types/wantType';

interface ISwitcherProps {
  onActiveItemId: (newItem: EWantTypeId) => void;
  itemId: EWantTypeId;
}

export const Switcher: React.FC<ISwitcherProps> = ({ onActiveItemId, itemId }) => {
  const device = useDeviceType();

  const isPhone = device === 'phone';

  const SwitcherTitle = isPhone ? ArticleHeading4 : ArticleHeading1;

  return (
    <div
      className={classnames(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['switcher-title']}>
        <SwitcherTitle color="decorative__theme__dark" textAlign={isPhone ? 'center' : 'left'}>
          Я хочу знать про
        </SwitcherTitle>
      </div>
      <div className={style['switcher']}>
        {WANT_KNOW_TYPE.map(({ id, text, imgClass }) => (
          <div
            className={classnames(style['item'], id === itemId && style['active'])}
            onClick={() => onActiveItemId(id)}
            key={id}
          >
            <div className={style[imgClass]} />
            <ArticleParagraph1
              color={id === itemId ? 'decorative__theme__dark' : 'decorative__subway__butovskaya'}
              fontWeight={id === itemId ? '700' : '400'}
            >
              {text}
            </ArticleParagraph1>
          </div>
        ))}
      </div>
    </div>
  );
};
